import serviceInterceptor from '../../../services/ServiceInterceptor';

export const getPendingTotals = () => serviceInterceptor('/pending-rebate-funds');